

import React, { Component } from 'react';
import { getFromDrupalAPI } from '../../fetchJSON.js';
import { decode } from 'he';
import _ from 'lodash';


class ParentingArticles extends Component {
  constructor() {
    super();
    this.state = {
      articles: null,
      page: 0,
      totalPages: null,
      totalArticles: null
    }
  }

  componentWillMount() {
    var that = this;

    getFromDrupalAPI('all_parenting_articles_api', function (data) {
      that.setState({ articles: data })
    });

    //getFromDrupalAPI('all_sermons_api?limit=20', function(data){
    //  that.setState({sermons: data})
    //});

    //get count of total sermons for pages
    //getFromDrupalAPI('all_sermons_api', function(data){
    //    var pages = Math.floor(data.length/20) +1
    //  that.setState({totalSermons: data.length, sermonPages: pages})
    //  });
  }


  render() {
    var blogArticles;
    if (this.state.articles) {
      blogArticles = _.map(this.state.articles, (article) => {
        return (
          <div className="item" key={_.uniqueId()}>
            <div className="item-title">
              <h2><a href={"/ParentingArticle/" + article.nid + "/" + decode(article.node_title.replace(/ /g, "_"))}>{decode(article.node_title)}</a></h2>
              <span className="label label-default light">{article.date}</span>
            </div>

            <div dangerouslySetInnerHTML={{ __html: decode(article.body) }} />

            <hr />
          </div>

        )
      });
    }
    else {
      blogArticles = <div>Loading articles...</div>;
    }

    return (
      <section>
        <header id="page-title">
          <div className="container">
            <h1>Parenting Articles</h1>
          </div>
        </header>
        <section className="container">

          {blogArticles}


          {/*!-- PAGINATION -->
          <div className="text-center">
          Pagination example:<br/>
            <ul className="pagination">
              <li><a href="#"><i className="fa fa-chevron-left"></i></a></li>
              <li className="active"><a href="#">1</a></li>
              <li><a href="#">2</a></li>
              <li><a href="#">3</a></li>
              <li><a href="#">4</a></li>
              <li><a href="#">5</a></li>
              <li><a href="#"><i className="fa fa-chevron-right"></i></a></li>
            </ul>
          </div>
          !-- /PAGINATION -->*/}

        </section>
      </section>
    );
  }
}

export default ParentingArticles;
